import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Checkbox, Grid, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';

import { ShowStaffUserOnly } from 'components/ConditionalWrappers/IsStaffWrapper/ShowStaffUserOnly';
import {
  OrderSummaryTable,
  ServicesRequestedTable,
  ShippingTable,
} from 'components/OrderForm/components/ReviewTables';
import { ShipSpecifications } from 'components/OrderForm/BillingShipping/BillingShippingComponents';
import { SubmittingIcon } from 'components/icons/LoadingIcon';
// import { NoSamplesConfirmModal } from 'components/OrderForm/Review/NoSamplesConfirmModal';

import {
  useGetReviewViewData,
  useReviewViewSubmit,
} from 'components/OrderForm/Review/hooks';

import { PLACE_ORDER_REVIEW_STEP_URL_V2 } from 'constants/urls';

import { useReviewViewStyles } from 'components/OrderForm/Review/styles';

export const ReviewView = () => {
  const [confirmDropbox, setConfirmDropbox] = useState(true);
  const [confirmMinimumOrderTotal, setConfirmMinimumOrderTotal] =
    useState(false);
  const [confirmHumanSamples, setConfirmHumanSamples] = useState(false);
  // const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);

  const { orderUUID, order, samples, isDropbox, isDemoUser } =
    useGetReviewViewData();
  const { submitting, handleReviewSubmit } = useReviewViewSubmit({
    orderUUID,
    order,
  });

  const disabledSubmitBtn =
    isDemoUser ||
    submitting ||
    !(confirmMinimumOrderTotal && confirmDropbox && confirmHumanSamples);

  const { classes } = useReviewViewStyles();

  const newUrl = PLACE_ORDER_REVIEW_STEP_URL_V2.replace(
    ':orderUUID',
    orderUUID,
  );

  useEffect(() => {
    if (isDropbox && !confirmDropbox) {
      setConfirmDropbox(false);
    }
  }, [confirmDropbox, isDropbox]);

  // const handleSubmit = () => {
  //   if (!samples.length) {
  //     setIsConfirmModalVisible(true);
  //   } else {
  //     handleReviewSubmit();
  //   }
  // };

  // commented out to remove this issue of it appearing
  const handleSubmit = () => {
    handleReviewSubmit();
  };

  // const onModalClose = () => {
  //   setIsConfirmModalVisible(false);
  // };

  if (!order || !samples) {
    return null;
  }

  return (
    <div>
      <ShowStaffUserOnly>
        <Typography variant="body2" align="center">
          Click <Link to={newUrl}>here</Link> to use the new order form.
        </Typography>
      </ShowStaffUserOnly>
      <OrderSummaryTable order={order} />
      <ServicesRequestedTable order={order} samples={samples} />
      <ShippingTable order={order} />
      {isDropbox && (
        <Paper className={classes.confirmPaper}>
          <Checkbox
            checked={confirmDropbox}
            onChange={(event) => setConfirmDropbox(event.target.checked)}
            value="confirmDropbox"
          />
          <span>
            I will place my samples in the Dropbox with the order number by the
            HistoWiz pickup time. I understand I am responsible for additional
            storage fee if I do not pick up my completed orders from the Dropbox
            within 30 days.
          </span>
        </Paper>
      )}
      <Paper className={classes.confirmPaper}>
        <Grid container direction="row" wrap="nowrap" alignItems="baseline">
          <Grid item>
            <Checkbox
              checked={confirmMinimumOrderTotal}
              onChange={(event) =>
                setConfirmMinimumOrderTotal(event.target.checked)
              }
              value="confirmMinimumOrderTotal"
            />
          </Grid>
          <Grid item>
            <span>
              I confirm that this order is either a first time free trial OR
              that it will be charged a total of $1,000 minimum if it does not
              meet the $1,000 minimum order size (I understand there is a 4 slide
              per marker minimum requirement for IHC and special stain services.
              I will be charged the 4 slides for each marker that does not meet
              this requirement).
            </span>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.confirmPaper}>
        <Grid container direction="row" wrap="nowrap" alignItems="baseline">
          <Grid item>
            <Checkbox
              checked={confirmHumanSamples}
              onChange={(event) => setConfirmHumanSamples(event.target.checked)}
              value="confirmHumanSamples"
            />
          </Grid>
          <Grid item>
            <span>
              I understand and agree that the work done by HistoWiz is expected
              to be for research purposes only and will not be used in
              diagnostic/clinical decision making.
            </span>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.confirmPaper}>
        <ShipSpecifications />
      </Paper>
      <div className={classes.saveButton}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={disabledSubmitBtn}
        >
          <SubmittingIcon submitting={submitting} />
          {isDemoUser ? 'This is A Demo Account!' : 'Submit Order'}
        </Button>
      </div>
      {/* {isConfirmModalVisible && ( */}
      {/*   <NoSamplesConfirmModal */}
      {/*     submitting={submitting} */}
      {/*     onClose={onModalClose} */}
      {/*     onSubmit={handleReviewSubmit} */}
      {/*   /> */}
      {/* )} */}
    </div>
  );
};
